import React, { Fragment, useReducer } from 'react'
import Modal from '../../components/UI/Modal/Modal'
import { useTranslation } from "react-i18next";

const AlertContext = React.createContext(
    {
        showAlert: () => { },
        hideAlert: () => { }
    })


const alertReducerInitState = { active: false, body: '', title: '', size: 'sm', onHideHandler: null }

const alertReducerFunc = (state, action) => {
    if (action.type === 'ACTIVE_ALERT') {
        return { active: true, body: action.body, title: action.title, size: action.size, onHideHandler: action.onHideHandler }
    }
    else if (action.type === 'INACTIVE_ALERT') {
        return alertReducerInitState
    }
    return state
}

export const AlertContextProvider = (props) => {
    const [alertMsg, alertMsgDispatch] = useReducer(alertReducerFunc, alertReducerInitState)
    const [t] = useTranslation('common')

    const handleOnShowAlert = (title = '', body = '', size = 'sm', onHideHandler) => {
        alertMsgDispatch({
            type: 'ACTIVE_ALERT',
            title,
            body,
            size,
            onHideHandler
        })
    }

    const handleOnHideAlert = () => {
        if (alertMsg.onHideHandler) {
            alertMsg.onHideHandler()
        }
        alertMsgDispatch({
            type: 'INACTIVE_ALERT'
        })
    }

    return <AlertContext.Provider value={{ showAlert: handleOnShowAlert, hideAlert: handleOnHideAlert }}>
        <Fragment>
            <Modal
                modalTitle={alertMsg.title}
                size={alertMsg.size}
                show={alertMsg.active}
                onHide={() => alertMsgDispatch({ type: 'INACTIVE_ALERT' })}
                // modalBody={alertMsg.body}
                modalBody={
                    alertMsg.isScrollable ? (<div style={{ whiteSpace: 'pre-wrap', maxHeight: '300px', overflowY: 'auto' }}>{alertMsg.body}</div>) : (alertMsg.body)
                }
                btnList={[
                    {
                        key: 'close',
                        action: 'close',
                        title: t('Close'),
                        onClick: handleOnHideAlert
                    }
                ]}
            />
            {props.children}
        </Fragment>
    </AlertContext.Provider>
}


export default AlertContext